// Drie stipjes die "er wordt getypt" betekenen.
//
// De stipjes zijn DECORATIE: aria-hidden, en de betekenis staat in de tekst
// ernaast. Onder prefers-reduced-motion bevriest de globale regel in
// theme.css:801 de animatie tot drie stille stipjes — de informatie blijft, de
// versiering gaat weg (theme.css:694).
//
// bg-ink-4 mag hier: theme.css:41-43 zegt dat ink-400 GEEN tekstkleur is, maar
// wel bedoeld voor randen, uitgeschakelde bediening en decoratieve iconen.
export function TypingDots({ label }: { label: string }) {
  return (
    <div className="flex items-center gap-2 px-1 py-1">
      <span className="flex items-center gap-1" aria-hidden>
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="size-1.5 rounded-full bg-ink-4 motion-safe:animate-typing-dot"
            style={{ animationDelay: `${i * 0.15}s` }}
          />
        ))}
      </span>
      {/* Niet in een live region: elke twee seconden "X typt" laten omroepen is
          onbruikbaar. De aankondiging gebeurt bij het BERICHT. */}
      <span className="text-sm text-ink-3" aria-hidden>
        {label}
      </span>
    </div>
  );
}
